import { RootState } from '../rootReducer';
import { IDomain } from '../../types';

// Domain selectors
export const selectDomainsLoading = (state: RootState): boolean => state.domain.loading;
export const selectDomainsError = (state: RootState): string | null => state.domain.error;
export const selectDomains = (state: RootState): IDomain[] => state.domain.domains;
export const selectSelectedDomain = (state: RootState): IDomain | null => state.domain.selectedDomain;
export const selectDomainVerificationLoading = (state: RootState): boolean => state.domain.verificationLoading; 
export const selectDomainSuccess = (state: RootState): boolean => state.domain.success;